var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, LILAC_400, WHITE, useBreakpoint, getTestId, InView, isValidObject } from '@airtel/air-design-system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlatList, View } from 'react-native';
import { PackCardWidget } from '../pack-card-widget';
import { getPlanListWidgetStyles, getRenderListData } from './PlanListWidgetStyles';
import { PlanListFooter } from './components/plan-list-footer';
import { CalloutWidget } from '../callout-widget';
export var PlanListWidgetComponent = props => {
  var _a;
  var _useState = useState(false),
    showFullList = _useState[0],
    setShowFullList = _useState[1];
  var GAP = 24;
  var _props$planListData = props.planListData,
    planListData = _props$planListData === void 0 ? [] : _props$planListData,
    _props$showExpandCta = props.showExpandCta,
    showExpandCta = _props$showExpandCta === void 0 ? true : _props$showExpandCta,
    _props$expandCtaData = props.expandCtaData,
    expandCtaData = _props$expandCtaData === void 0 ? {} : _props$expandCtaData,
    _props$numOfCardSTobe = props.numOfCardSTobeShownPerRow,
    numOfCardSTobeShownPerRow = _props$numOfCardSTobe === void 0 ? 3 : _props$numOfCardSTobe,
    _props$allowMdAsLarge = props.allowMdAsLargeScreen,
    allowMdAsLargeScreen = _props$allowMdAsLarge === void 0 ? false : _props$allowMdAsLarge,
    _props$showBlankSpace = props.showBlankSpacesInCard,
    showBlankSpacesInCard = _props$showBlankSpace === void 0 ? false : _props$showBlankSpace,
    id = props.id,
    onUserAction = props.onUserAction,
    style = props.style,
    packSelectionCardBorderColor = props.packSelectionCardBorderColor,
    packCardBackgroundColor = props.packCardBackgroundColor,
    planCardLeftCtaPress = props.planCardLeftCtaPress,
    planCardRightCtaPress = props.planCardRightCtaPress,
    _props$showPackDivide = props.showPackDivider,
    showPackDivider = _props$showPackDivide === void 0 ? false : _props$showPackDivide,
    _props$showPackSelect = props.showPackSelection,
    showPackSelection = _props$showPackSelect === void 0 ? false : _props$showPackSelect,
    _props$selectedPackIn = props.selectedPackIndex,
    _selectedPackIndex = _props$selectedPackIn === void 0 ? -1 : _props$selectedPackIn,
    _props$commonPlanCard = props.commonPlanCardProps,
    commonPlanCardProps = _props$commonPlanCard === void 0 ? {} : _props$commonPlanCard,
    _props$showSeprator = props.showSeprator,
    showSeprator = _props$showSeprator === void 0 ? true : _props$showSeprator,
    testID = props.testID,
    onItemVisibleMetaData = props.onItemVisibleMetaData,
    inViewTriggerOnce = props.inViewTriggerOnce,
    calloutProps = props.calloutProps,
    restProps = __rest(props, ["planListData", "showExpandCta", "expandCtaData", "numOfCardSTobeShownPerRow", "allowMdAsLargeScreen", "showBlankSpacesInCard", "id", "onUserAction", "style", "packSelectionCardBorderColor", "packCardBackgroundColor", "planCardLeftCtaPress", "planCardRightCtaPress", "showPackDivider", "showPackSelection", "selectedPackIndex", "commonPlanCardProps", "showSeprator", "testID", "onItemVisibleMetaData", "inViewTriggerOnce", "calloutProps"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true,
      allowMdAsLargeScreen
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useState2 = useState(_selectedPackIndex),
    selectedPackIndex = _useState2[0],
    setSelectedPackIndex = _useState2[1];
  useEffect(() => {
    setSelectedPackIndex(_selectedPackIndex);
  }, [_selectedPackIndex]);
  var planListWidgetStyles = getPlanListWidgetStyles(isLargeScreen);
  var _expandCtaData$initia = expandCtaData.initialItemCount,
    initialItemCount = _expandCtaData$initia === void 0 ? isLargeScreen ? 3 : 4 : _expandCtaData$initia;
  var cardsPerRow = isLargeScreen ? numOfCardSTobeShownPerRow : 1;
  var setOfVisitedIds = useRef(new Set());
  var renderedData = getRenderListData(showFullList, showExpandCta, planListData, initialItemCount);
  var showEmptySpace = ((_a = planListData === null || planListData === void 0 ? void 0 : planListData.filter(planList => {
    var _a;
    return ((_a = planList === null || planList === void 0 ? void 0 : planList.infoTagArray) === null || _a === void 0 ? void 0 : _a.length) > 0;
  })) === null || _a === void 0 ? void 0 : _a.length) > 0;
  var toggleShowFullList = () => {
    setShowFullList(!showFullList);
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      if (((_c = (_b = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _b === void 0 ? void 0 : _b[i]) === null || _c === void 0 ? void 0 : _c.index) != null && !((_d = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _d === void 0 ? void 0 : _d.has((_e = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _e === void 0 ? void 0 : _e.index))) {
        (_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index);
        ((_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onPlanCardVisibleMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, (_l = (_k = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _k === void 0 ? void 0 : _k[i].item) === null || _l === void 0 ? void 0 : _l.onPlanCardVisibleMetaData), (_m = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _m === void 0 ? void 0 : _m.item));
      }
    }
  }, []);
  var emptyBox = cardsPerRow - ((renderedData === null || renderedData === void 0 ? void 0 : renderedData.length) || 0) % cardsPerRow;
  var onPackSelectionHandler = index => {
    if (showPackSelection) setSelectedPackIndex(index);
  };
  if (planListData.length == 0) {
    return null;
  }
  return _jsxs(View, Object.assign({
    style: [isLargeScreen && {
      marginRight: -GAP
    }, style]
  }, {
    children: [!!isValidObject(calloutProps) && _jsx(CalloutWidget, Object.assign({}, calloutProps, {
      style: [planListWidgetStyles.calloutStyle, calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.style],
      onUserAction: calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.onUserAction
    }, getTestId(testID + '_calloutwidget'))), _createElement(FlatList, Object.assign({}, getTestId(testID, 'list'), {
      viewabilityConfig: {
        itemVisiblePercentThreshold: 100
      },
      keyboardShouldPersistTaps: "handled",
      onViewableItemsChanged: onViewableItemsChanged,
      renderItem: _ref => {
        var item = _ref.item,
          index = _ref.index;
        var _a, _b;
        return _jsx(InView, Object.assign({
          triggerOnce: inViewTriggerOnce,
          onChange: inView => {
            inView && onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onItemVisibleMetaData), Object.assign({
              index
            }, item)));
          },
          style: {
            flex: 1,
            marginRight: isLargeScreen ? GAP : 0
          }
        }, {
          children: _createElement(PackCardWidget, Object.assign({}, getTestId(testID, 'listItem'), {
            key: "list_item__" + index,
            showEmptyInfoTagContainer: cardsPerRow !== 1 && showEmptySpace && showBlankSpacesInCard,
            showAdditionalBenefits: cardsPerRow !== 1 && showBlankSpacesInCard,
            id: id,
            index: index,
            onUserAction: onUserAction
          }, commonPlanCardProps, item, {
            onCardPressHandler: () => {
              onPackSelectionHandler(index);
            },
            showPackSelection: showPackSelection,
            isSelected: showPackSelection && selectedPackIndex === index,
            onLeftCtaPress: (item === null || item === void 0 ? void 0 : item.onLeftCtaPress) || planCardLeftCtaPress,
            onRightCtaPress: (item === null || item === void 0 ? void 0 : item.onRightCtaPress) || planCardRightCtaPress,
            packSelectionCardBorderColor: packSelectionCardBorderColor,
            packCardBackgroundColor: packCardBackgroundColor,
            buttonWidgetData: Object.assign(Object.assign(Object.assign({}, commonPlanCardProps === null || commonPlanCardProps === void 0 ? void 0 : commonPlanCardProps.buttonWidgetData), item === null || item === void 0 ? void 0 : item.buttonWidgetData), {
              rightCta: Object.assign(Object.assign(Object.assign({}, (_a = commonPlanCardProps === null || commonPlanCardProps === void 0 ? void 0 : commonPlanCardProps.buttonWidgetData) === null || _a === void 0 ? void 0 : _a.rightCta), (_b = item.buttonWidgetData) === null || _b === void 0 ? void 0 : _b.rightCta), {
                onPress: () => onPackSelectionHandler(index)
              })
            })
          }))
        }));
      },
      data: [...renderedData, ...Array(emptyBox).fill({
        showEmptyBox: true
      })],
      ListFooterComponent: showExpandCta && _jsx(PlanListFooter, Object.assign({}, getTestId(testID, 'planList'), {
        showFullList: showFullList,
        toggleShowFullList: toggleShowFullList
      }, props)),
      ItemSeparatorComponent: () => showPackDivider ? _jsx(Divider, {
        height: 2,
        color: LILAC_400,
        shadowColor: WHITE
      }) : showSeprator && _jsx(View, {
        style: planListWidgetStyles.packCard
      }),
      key: "list_item_" + cardsPerRow,
      keyExtractor: (_, index) => "list_item_" + index,
      showsVerticalScrollIndicator: false,
      numColumns: cardsPerRow,
      horizontal: false
    }, restProps))]
  }));
};
PlanListWidgetComponent.genericRendererKey = 'AirPlanListWidget';